import React from 'react';
import styled from "../../styled-components.mjs";
import { cssSpacing, rootStyle } from "../../styles/index.mjs";
var IconSpacer = styled.span.withConfig({
  displayName: "Icon__IconSpacer",
  componentId: "sc-1hpzz1n-0"
})(["", ";padding:", ";display:inline-flex;"], rootStyle(), cssSpacing('tighter-4', '4px'));
export var ChipIcon = function ChipIcon(_ref) {
  var icon = _ref.icon,
    size = _ref.size;
  var Icon = icon;
  return /*#__PURE__*/React.createElement(IconSpacer, null, /*#__PURE__*/React.createElement(Icon, {
    size: size
  }));
};